'use strict';

export enum DataStatus {
  initial = 'initial',
  updating = 'updating',
  success = 'success',
  fail = 'fail',
}
